import { Container } from "react-bootstrap";
import Migas from "../migasGeomedellin/Migas";
import PiePagina from "../piePagina/PiePagina";
import { NavLink } from "react-router-dom";

export default function MapaNavegacion() {
  return (
    <>
      <Container fluid={true}>
        <Migas ruta={"Mapa del Sitio"} />
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Inicio</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegacioninicio"
                  to={"/"}
                  className="lista-mapa"
                >
                  <a href="##" className="ref-lista-mapa">
                    Inicio
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Aplicaciones</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegacionaplicacion"
                  className="lista-mapa"
                  to={"/aplicaciones"}
                >
                  <a href="##" className="ref-lista-mapa">
                    Aplicaciones
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Geoservicios</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegacion"
                  className="lista-mapa"
                  to={"/geoServicios"}
                >
                  <a href="##" className="ref-lista-mapa">
                    {" "}
                    Geoservicios
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Datos abiertos</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegaciondatoabierto"
                  className="lista-mapa"
                  to={"/datosAbiertos"}
                >
                  <a href="##" className="ref-lista-mapa">
                    {" "}
                    Datos abiertos{" "}
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Documentación</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegaciondocumentacion"
                  className="lista-mapa"
                  to={"/documentacion"}
                >
                  <a href="##" className="ref-lista-mapa">
                    {" "}
                    Documentación{" "}
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Ayudas</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegacionayudas"
                  className="lista-mapa"
                  to={"/ayudas"}
                >
                  <a href="##" className="ref-lista-mapa">
                    Ayudas{" "}
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
        <div className="mapa-sitio">
          <div className="modsite-map">
            <h2 className="title-mapassitio">Noticias</h2>
            <Container>
              <ul>
                <NavLink
                  id="mapanavegacionnoticias"
                  className="lista-mapa"
                  to={"/noticias"}
                >
                  <a href="##" className="ref-lista-mapa">
                    Noticias{" "}
                  </a>
                </NavLink>
              </ul>
            </Container>
          </div>
        </div>
      </Container>
      <PiePagina fluid={true} />
    </>
  );
}
